import getInstancesFromDomainMapReduxUtil from 'modules/redux/utils/legacy/get-instances-from-domain-map'
import { getObjectUtil } from 'packages/src'

/**
 * Gets the instances from the given Domain.
 * @param  {DomainMap} domainMap
 * @param  {string} [domainListPath='all']
 * @returns {Instance[]}
 */
function getInstancesDomainUtil (domainMap, domainListPath = 'all') {
  return getInstancesFromDomainMapReduxUtil(
    getObjectUtil(domainMap, 'data'),
    getObjectUtil(domainMap, `${domainListPath}.data`)
  )
}

export {
  getInstancesDomainUtil
}
